import ColumnBase from "./ColumnBase.jsx";
import {WIDGET_KEYS} from "../../other/constants/WidgetKeys.jsx";
import {ColumnStore} from "@bryntum/schedulerpro";
import {imageIconDefaultString, imageIconRenderer} from "../../other/utils/utils.jsx";

export default class ImageColumn extends ColumnBase {
  static get $name() {
    return "ImageColumn";
  }

  static get type() {
    return WIDGET_KEYS.imageColumn;
  }

  static get defaults() {
    return {
      text: "Image",
      width: 30,
      editor: false,
      searchable: false,
      align: "center",
      sealed: true,
      filterable: false,
      htmlEncode: false,
      headerRenderer() {
        return imageIconDefaultString();
      },
      renderer({ value }) {
        if (value) {
          return {
            tag: "img",
            class: `w-[3em] h-[3em] object-contain`,
            src: value,
          }
        }
        return imageIconRenderer(Boolean(value))
      },
      groupRenderer({ groupRowFor }) {
        return imageIconRenderer(Boolean(groupRowFor))
      }
    }
  }
}

ColumnStore.registerColumnType(ImageColumn);
